import { render } from "./market-color.vue?vue&type=template&id=31fea2fc&scoped=true"
import script from "./market-color.vue?vue&type=script&lang=js"
export * from "./market-color.vue?vue&type=script&lang=js"

import "./market-color.vue?vue&type=style&index=0&id=31fea2fc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31fea2fc"]])

export default __exports__